"use client";

import Image from "next/image";
import FaIcon from "../FaIcon";
import FooterLink from "./FooterLink";

import logo from "./images/kinerva_logo_slogan_vertical.png";
import twitter from "./images/twitter-logo.png";
import iso from "./images/ISO27001certified.svg";
const styles = new Proxy({"Footer":"Footer-e6a2e","FooterLogoWrapper":"FooterLogoWrapper-e6a2e","FooterLogo":"FooterLogo-e6a2e","Info":"Info-e6a2e","Offices":"Offices-e6a2e","Twitter":"Twitter-e6a2e","MenuWrapper":"MenuWrapper-e6a2e","MenuItem":"MenuItem-e6a2e"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });

const currentYear = new Date().getFullYear();

const Footer = () => (
  <footer>
    <div className={styles.Footer}>
      <div className="container py-5">
        <div className="row">
          <div className="col-lg-12 p-4 p-lg-0">
            <div className={`mb-4 text-center ${styles.FooterLogoWrapper}`}>
              <Image
                src={logo}
                className={styles.FooterLogo}
                alt="Kinerva"
                sizes="(max-width: 768px) 80vw, 400px"
                height={72}
                width={298}
                loading="lazy"
              />
            </div>
            <div className={styles.FooterLogoWrapper}>
              Developed by &copy; {currentYear}, Cursor Insight Ltd
            </div>
            <div className={styles.Info}>
              <FooterLink to="https://cursorinsight.com/document/cookie-policy">
                Cookie Policy
              </FooterLink>
              |
              <FooterLink to="https://cursorinsight.com/document/privacy-policy">
                Privacy Policy
              </FooterLink>
            </div>
            <div className={`mb-4 ${styles.FooterLogoWrapper}`}>
              <FaIcon
                imgSrc={twitter}
                href="https://twitter.com/cursorinsight"
              />

              <FaIcon
                id="fa-linkedin"
                href="https://www.linkedin.com/company/cursor-insight"
              />

              <FaIcon
                id="fa-facebook"
                href="https://www.facebook.com/cursorinsight"
              />

              <FaIcon id="fa-github" href="https://github.com/cursorinsight" />

              <FaIcon
                id="fa-youtube"
                href="https://www.youtube.com/@cursorinsight7572"
              />
            </div>
            <div className={styles.Offices}>
              <span>London&nbsp;|&nbsp;United Kingdom</span>
              <span>Budapest&nbsp;|&nbsp;Hungary</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
